import { IContactsAction, IContactsContextState } from './contacts-interfaces';
import { contactsActionTypes } from './contacts-action-types';

export const contactsReducer = (state: IContactsContextState, action: IContactsAction): IContactsContextState => {
	switch (action.type) {
		case contactsActionTypes.SET_ADD_CONTACT_LOADING: {
			return { ...state, isAddContactLoading: action.payload };
		}
		case contactsActionTypes.SET_CONTACT_DETAILS_LOADING: {
			return { ...state, isContactDetailsLoading: action.payload };
		}
		case contactsActionTypes.FETCH_CONTACT_DETAILS_DATA: {
			return { ...state, contactDetails: action.payload, isContactDetailsLoading: false };
		}
	}
};
